import GlobalDispatcher from 'Engine/events/GlobalDispatcher';
import SlotGameModel from 'Engine/slots/model/SlotGameModel';
import eBigWinDefaultCoefs from '../enums/eBigWinDefaultCoefs';
import eBigWinTypes from '../enums/eBigWinTypes';
import ServerManager from '../server/ServerManager';
import eEventTypes from '../enums/eEventTypes';
import StatesManager from 'Engine/base/states/StatesManager';
import eBonusPurchaseCards from '../enums/eBonusPurchaseCards';
import eStateTypes from '../enums/eStateTypes';

export default new class GameModel extends SlotGameModel {
  constructor() {
    super();
    this._freespins = 0;
    this._freespinsTotalWin = 0;
    this._freespinsTriggered = false;

    GlobalDispatcher.addOnce(eEventTypes.EET_DATA_UPDATED,() => {
      this._winRankCoef = {
        [eBigWinTypes.EBWT_WIN]: eBigWinDefaultCoefs.EBWC_WIN,
        [eBigWinTypes.EBWT_BIG_WIN]:  OPWrapperService.config.minWinRankCoef ? OPWrapperService.config.minWinRankCoef : eBigWinDefaultCoefs.EBWC_BIG_WIN,
        [eBigWinTypes.EBWT_MEGA_WIN]: eBigWinDefaultCoefs.EBWC_MEGA_WIN,
        [eBigWinTypes.EBWT_EPIC_WIN]: eBigWinDefaultCoefs.EBWC_EPIC_WIN
    };
    }, this);
  }

  init () {
    super.init();
    ServerManager.onInit();
  }


  setNewData(data) {
    super.setNewData(data);

    if (data.freespinsData) {
      this._freespinsTotalWin = data.freespinsData.totalWin || 0;
      this._freespins = data.freespinsData.freespins;
      this._freespinsTriggered = data.freespinsData.freespinsTriggered;
      this._freespinsCountGiven = data.freespinsData.freespinsCountGiven;
    }
    this._isFreeSpinsMode = data.freespinsData && data.freespinsData.isFreespinsGame;
    this._wilds = data.wilds;

    if (data.hasOwnProperty('bonusCostMultiplier')) this.bonusCostMultiplier = data.bonusCostMultiplier;

    GlobalDispatcher.dispatch(eEventTypes.EET_DATA_UPDATED, data.action);
  }

  changeBet(index) {
    if (index >= this._betPossible.length) index = this._betPossible.length - 1;
    if (index < 0) index = 0;

    this.betIndex = index;
  }

  buyBonus({ params }) {
    if (params.price > this.balance) {
      window.OPWrapperService.showError(window.OPWrapperService.errors.INSUFFICIENT_BALANCE_CLIENT.CODE);
      return;
    }
    this.bonusPurchaseData = params;
    StatesManager.goToState(eStateTypes.EST_BUY_BONUS);
  }

  getBonusPurchasePrice(type) {
    return this.bet * this.bonusCostMultiplier;
  }

  isPurchaseCardAvailable(type) {
    switch (type) {
      case eBonusPurchaseCards.EBPT_FREE_SPINS.type:
        return true;
      default:
        return false;
    }
  }

  get paytableCurrentInfo() {
    this._paytableCurrentInfo = {}
    for (const index in this._paytableInfo) {
      this._paytableCurrentInfo[index] = this._paytableInfo[index].map(coef => {
        return `×${coef}`;
      })
    }
    this._paytableCurrentInfo['wildField'] = this._paytableInfo[1][2] * this.lines

    return this._paytableCurrentInfo
  }

  get freespins() {
    return this._freespins;
  }
  set freespins(value) {
    this._freespins = value;
  }
  get freespinsTotalWin() {
    return this._freespinsTotalWin;
  }
  set freespinsTotalWin(value) {
    this._freespinsTotalWin = value;
  }
  get freespinsCountGiven() {
    return this._freespinsCountGiven;
  }
  get isFreeSpinsMode() {
    return this._isFreeSpinsMode;
  }
  get freespinsEnabled() {
    return this._bonusGameEnabled;
  }
  set freespinsEnabled(value) {
    this._bonusGameEnabled = value;
    this._isSpinWithoutBalanceCheck = value;
  }
  get freespinsTriggered() {
    return this._freespinsTriggered;
  }
  get totalWin() {
    let win = 0
    if (this._winnings) {
      win += this.winnings.totalWin;
    }
    return win;
  }
  get winRankCoef () {
    return this._winRankCoef;
  }
  get bonusPurchaseData() {
    return this._bonusPurchaseData;
  }
  set bonusPurchaseData(value) {
    this._bonusPurchaseData = value;
  }

 get wildsData() {
    return this._wilds;
 }

 get isWildsFeature() {
    return this._wilds.some(data => data.length);
 }
}
